import { useCompanyApi } from '@lendica/hooks';
import { useMemo } from 'react';

export const useDataConnectionApi = () => {
    const api = useCompanyApi();
    return useMemo(
        () => ({
            getDataConnectionsList: (page = 1, pageSize = 50) =>
                api.get('/connections/list', {
                    params: {
                        page,
                        page_size: pageSize,
                    },
                }),
        }),
        [api]
    );
};
